import {Component, OnInit} from '@angular/core';
import {ListingService} from '../../services/listing.service';
import {CommonService} from '../../services/common.service';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {IframeButtonComponent} from './iframe-button/app.component';
import {UserService} from '../../services/user.service';
import * as CryptoJS from 'crypto-js';
import environment from '../../../environment';
import {isValidTemporaryLink} from './temporary-link';

@Component({
  selector: 'listing-test',
  templateUrl: 'app.component.html',
  styleUrl: 'app.component.scss',
  standalone: false,
})
export class ListingComponent implements OnInit {
  public listing: any;
  public relatedContent: any;
  public isUrl: boolean;
  public isFilmology: boolean;
  public isOdney: boolean;
  public iframe: any;
  public isProduct: boolean;
  public isTicket: boolean;
  public loading: boolean;
  public listingId: string;
  public listingSlug: string;

  constructor(
    protected listingService: ListingService,
    public commonService: CommonService,
    protected Dialog: MatDialog,
    protected userService: UserService
  ) {}

  ngOnInit(): void {
    this.getData();
  }

  private getListingId(): string {
    return window.location.pathname.split('/')[2];
  }

  private getListingSlug(): string {
    return window.location.pathname.split('/')[3];
  }

  async getData() {
    this.loading = true;
    this.listingId = this.getListingId();
    this.listingSlug = this.getListingSlug();

    try {
      const listing = await this.listingService.load(this.listingId);

      if (await this.shouldRedirect(listing)) {
        this.redirectToHome();
        return;
      }

      if (listing.video) {
        const newImages = listing.ProductImage;
        newImages.push({id: 'video', video: listing.video});
        this.listing = {...listing, ProductImage: newImages};
      } else {
        this.listing = listing;
      }

      this.isUrl = !!listing.features?.external_url;
      this.isFilmology = !!listing.features.filmology;
      this.iframe = listing.features.iframe
        ? {title: 'Open Issuu Magazine', ...listing.features.iframe}
        : null;
      this.isProduct = listing.features.purchasable && listing.features.product;
      this.isOdney = listing.features.purchasable && listing.features.odney;
      this.isTicket =
        !!listing.features.purchasable &&
        (listing.features.ticket || listing.features.ballot);
      this.listingService
        .loadRelatedContent(this.listingId)
        .then(data => (this.relatedContent = data));
    } catch (error) {
      if (environment.settings.verboseLogging) {
        console.error('Error loading listing:', error);
      }
      this.redirectToHome();
    } finally {
      this.loading = false;
    }
  }

  private async shouldRedirect(listing: any): Promise<boolean> {
    if (
      !listing ||
      (listing.success === false && listing.reason === 'excluded_or_retired')
    ) {
      return true;
    }

    if (listing && !listing.branch_id && !listing.enabled) {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('preview')) {
        return await this.checkPreview(urlParams);
      } else if (urlParams.get('temp')) {
        return this.checkTemp(urlParams);
      }
      return true;
    }
    return false;
  }

  private redirectToHome(): void {
    window.location.href = '/';
  }

  private async checkPreview(previewParams: URLSearchParams): Promise<boolean> {
    const previewHash = previewParams.get('preview');
    if (!previewHash) {
      return true;
    }
    await this.userService.loadUser();
    const user = this.userService.User.value;
    if (user.User) {
      const json = {
        name: `${user.User.first_name} ${user.User.last_name}`,
        id: Number(this.listingId),
      };
      const hashed = CryptoJS.MD5(JSON.stringify(json)).toString();
      const previewValid = hashed === previewHash;
      return !previewValid;
    }
  }

  private checkTemp(tempParams: URLSearchParams): boolean {
    return !isValidTemporaryLink(
      this.listingId,
      this.listingSlug,
      tempParams.get('temp')
    );
  }

  public navigate(path: string) {
    window.location.href = path;
  }

  public showTheIssue() {
    const config = new MatDialogConfig();
    config.disableClose = true;
    config.data = this.listing.iframe;
    this.Dialog.open(IframeButtonComponent, config).afterClosed();
  }
}
